export default __webpack_public_path__ + "static/media/Group -12-TataNeu@2x.83f8b643.png";